import { _ } from "../../../core/polyglot/polyglot.js";
import { makeMonitorRepository } from "../../../core/repositories/repositoryBuilders.js";
import accountingDocument from "../../shared/accountingDocument.js";
import LiquidityReport from "../../../models/accounting/liquidityReport/LiquidityReport.js";
import LiquidityReportWidget from "./LiquidityReportWidget.js";
import optionsBag from "../../../models/options/optionsBag.js";
import session from "../../../core/session.js";

/**
 * `liquidityReportDocument` fetches a `liquidityReport` instance
 * from the server and displays it through a
 * `liquidityReportWidget`.
 */
export default accountingDocument.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);

		that.documentId = "liquidity-report";

		my.company = session.getCompany();

		my.currentUser = session.getCurrentUser();

		my.liquidityReportRepository = makeMonitorRepository({
			model: LiquidityReport,
			route: "/Accounting2/Company/#companyId/LiquidityReport/Current",
			defaultFilters: {
				companyId: my.company.getLegacyId(),
			},
			antiForgeryToken: session.getAntiForgeryToken(),
		});
	};

	my.initializeSubwidgets = function () {
		my.super(...arguments);
		that.title = _("Liquidity report");

		my.liquidityReportWidget = new LiquidityReportWidget({
			showInvoiceReportLinks: optionsBag.fromId("invoice").isActive(),
			editingDisabled: !my.currentUser.canEditLiquidityReport(my.company),
		});
	};

	that.show = function () {
		my.liquidityReportRepository.get().then((liquidityReport) => {
			my.liquidityReportWidget.setLiquidityReport(liquidityReport);
			that.showContent();
		});
	};

	my.renderContentOn = function (html) {
		html.render(
			my.section({
				content: my.liquidityReportWidget,
			}),
		);
	};

	that.renderActionsOn = function (html) {
		if (my.currentUser.canEditLiquidityReport(my.company)) {
			html.render(my.updateActionRenderer());
		}
		html.render(my.printActionRenderer());
	};

	my.updateActionRenderer = function () {
		return my.rightMenuSection(false, (html) => {
			html.div(
				html
					.a(
						{
							klass: "btn btn-block btn-default",
							"data-test": "save-and-update",
						},
						_("Save & Update"),
					)
					.click(my.refreshReport),
			);
		});
	};

	my.printActionRenderer = function () {
		return my.rightMenuSection(_("Printing"), (html) => {
			html.button(
				{ klass: "btn btn-default btn-block" },
				_("Print"),
			).click(() => window.print());
		});
	};

	my.refreshReport = function () {
		my.liquidityReportRepository
			.update({
				model: my.liquidityReportWidget.getLiquidityReport(),
			})
			.then((newReport) => {
				my.liquidityReportWidget.setLiquidityReport(newReport);
			});
	};
});
